(function (angular) {
    'use strict';

    window.THF.Angular.JoinForm.factory('thfFieldDefinitionPersonal', function () {
        return {

            'memberTitle': {
                'label': 'Title',
                'labelStyle': '',
                'name': 'memberTitle',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [],
                'onChange': function (newValue, oldValue, tabModel, formModel, field) {
                    // Find the first item that matches the value.
                    var title = _.find(field.options, { value: newValue });
                    if (title.gender) {
                        formModel.personal.memberGender = title.gender;
                    }
                }

            },
            'memberFirstName': {
                'label': 'First Name',
                'labelStyle': '',
                'name': 'memberFirstName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 16,
                'onChange': function (newValue, oldValue, tabModel, formModel, field) {
                    if (formModel.personal.medicareFirstName == oldValue) {
                        formModel.personal.medicareFirstName = newValue;
                    }
                },
                'validation': [
                    'required'
                ]
            },
            'memberLastName': {
                'label': 'Last Name',
                'labelStyle': '',
                'name': 'memberLastName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 25,
                'onChange': function (newValue, oldValue, tabModel, formModel, field) {
                    if (formModel.personal.medicareLastName == oldValue) {
                        formModel.personal.medicareLastName = newValue;
                    }
                },
                'validation': [
                    'required'
                ]
            },
            'memberDOB': {
                'label': 'Date Of Birth',
                'name': 'memberDOB',
                'defaultValue': '',
                'placeholder': 'DD/MM/YYYY',
                'datePickerOptions': {
                    yearRange: '-110nn:-nn',
                    minDate: moment().month(0).subtract('110', 'years').toDate(),
                    maxDate: moment().toDate(),
                    defaultDate: moment().format('DD/MM/YYYY')
                },
                'tooltip': '',
                'mask': '99/99/9999',
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    formModel.cover.memberDOB = newValue;
                },
                'validation': [
                    'required',
                    'thfDateOfBirth'
                ]
            },
            'memberGender': {
                'label': 'Gender',
                'labelStyle': '',
                'name': 'memberGender',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [
                    { 'label': 'Male', 'value': 'M' },
                    { 'label': 'Female', 'value': 'F' }
                ]
            },
            // 'memberContinuousCover': {
            //     'label': '',
            //     'labelStyle': '',
            //     'name': 'memberContinuousCover',
            //     'defaultValue': '',
            //     'placeholder': '',
            //     'tooltip': 'The Federal Government Lifetime Health Cover initiative rewards those who take out Hospital cover before they turn 31. People who delay taking out Hospital cover will pay an additional 2% loading on top of their contributions for every year that they don\'t have Hospital cover over the age of 30. The loading ceases to apply once Hospital cover has been held for ten continuous years.',
            //     'options': [
            //         {
            //             'label': 'I have held continuous private hospital cover for the past 10 years (or since my 31st birthday)'
            //         }
            //     ],
            //     'validation': []
            // },
            'memberContinuousCover': {
                'label': 'I have held continuous private hospital cover for the past 10 years (or since my 31st birthday)',
                'labelStyle': '',
                'name': 'memberContinuousCover',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'The Federal Government Lifetime Health Cover initiative rewards those who take out Hospital cover before they turn 31. People who delay taking out Hospital cover will pay an additional 2% loading on top of their contributions for every year that they don\'t have Hospital cover over the age of 30. The loading ceases to apply once Hospital cover has been held for ten continuous years.',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': []
            },
            'medicareNumber': {
                'label': 'Medicare number?',
                'labelStyle': '',
                'name': 'medicareNumber',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'mask': '9999 99999 9',
                'validation': [
                    'required'
                ],
                'options': [
                    { 'label': 'Mr', 'value': 'MR' },
                    { 'label': 'Mrs', 'value': 'MRS' }
                ]
            },
            'medicareExpiry': {
                'label': 'Expiry',
                'labelStyle': '',
                'name': 'medicareExpiry',
                'defaultValue': moment().format('MM/YYYY'),
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ]
            },
            'medicareFirstName': {
                'label': 'Your first name (as it appears on your Medicare card)',
                'labelStyle': '',
                'name': 'medicareFirstName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 16,
                'validation': [
                    'required'
                ]
            },
            'medicareInitial': {
                'label': 'Your initial (as it appears on your Medicare card)',
                'labelStyle': '',
                'name': 'medicareInitial',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'mask': 'A',
                'validation': [
                ]
            },
            'medicareLastName': {
                'label': 'Your last name (as it appears on your Medicare card)',
                'labelStyle': '',
                'name': 'medicareLastName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 25,
                'validation': [
                    'required'
                ]
            },
            'previousFundAllSame': {
                'label': 'Are all the people to be covered switching from the same previous policy?',
                'labelStyle': '',
                'name': 'previousFundAllSame',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': [
                    'required'
                ]
            },
            'memberPreviousFundSwitching': {
                'label': 'Are you switching from another policy?',
                'labelStyle': '',
                'name': 'memberPreviousFundSwitching',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': [
                    'required'
                ]
            },
            'memberPreviousFundName': {
                'label': 'Previous Fund Name',
                'labelStyle': '',
                'name': 'memberPreviousFundName',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Select your previous fund\'s name.',
                'validation': [
                    'required'
                ],
                'options': []
            },
            'memberPreviousFundMemberNumber': {
                'label': 'Member Number (optional)',
                'labelStyle': '',
                'name': 'memberPreviousFundMemberNumber',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 20,
                'tooltip': 'If you have your member number handy, enter it here.',
                'validation': []
            },
            'memberPreviousFundAuthorisation': {
                'label': '',
                'labelStyle': '',
                'name': 'memberPreviousFundAuthorisation',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Giving us authority to contact your previous fund allows us to initiate the cancellation process and request your clearance certificate, giving us details of your previous cover and waiting periods served. If your spouse/partner is transferring from a separate membership, they will need to complete the clearance certificate request on our website. Simply visit the Members Area and select Resources &amp; Forms.',
                'validation': [
                ],
                'options': [
                    { 'label': 'I authorise ' + joinFormPageData.siteName + ' to contact my previous health fund on my behalf.', 'value': 'Y' }
                ]
            },









            'partnerTitle': {
                'label': 'Title',
                'labelStyle': '',
                'name': 'partnerTitle',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [],
                'onChange': function (newValue, oldValue, tabModel, formModel, field) {
                    // Find the first item that matches the value.
                    var title = _.find(field.options, { value: newValue });
                    if (title.gender) {
                        formModel.personal.partner.partnerGender = title.gender;
                    }
                }
            },
            'partnerRelationship': {
                'label': 'Relationship',
                'labelStyle': '',
                'name': 'partnerRelationship',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': []
            },
            'partnerFirstName': {
                'label': 'First Name',
                'labelStyle': '',
                'name': 'partnerFirstName',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 16,
                'validation': [
                    'required'
                ]
            },
            'partnerLastName': {
                'label': 'Last Name',
                'labelStyle': '',
                'name': 'partnerLastName',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 25,
                'validation': [
                    'required'
                ]
            },
            'partnerDOB': {
                'label': 'Date Of Birth',
                'name': 'partnerDOB',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': 'DD/MM/YYYY',
                'datePickerOptions': {
                    yearRange: '-110nn:-nn',
                    minDate: moment().month(0).subtract('110', 'years').toDate(),
                    maxDate: moment().toDate(),
                    defaultDate: moment().format('DD/MM/YYYY')
                },
                'onChange': function (newValue, oldValue, tabModel, formModel) {
                    formModel.cover.partnerDOB = newValue;
                },
                'tooltip': '',
                'validation': [
                    'required',
                    'thfDateOfBirth'
                ]
            },
            'partnerGender': {
                'label': 'Gender',
                'labelStyle': '',
                'name': 'partnerGender',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [
                    { 'label': 'Male', 'value': 'M' },
                    { 'label': 'Female', 'value': 'F' }
                ]
            },
            'partnerAuthorisation': {
                'label': '',
                'labelStyle': '',
                'name': 'partnerAuthorisation',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Providing authority to your partner to manage your membership means that they are given similar rights to you – the primary member. While they will be able to make enquiries and some changes to the membership, they can’t remove you as the primary member or cancel the membership.',
                'validation': [
                ],
                'options': [
                    { 'label': 'I authorise my partner to be a point of contact on behalf of this policy.', 'value': 'Y' }
                ]
            },

            'partnerPreviousFundSwitching': {
                'label': 'Is your partner switching from another policy?',
                'labelStyle': '',
                'name': 'partnerPreviousFundSwitching',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': [
                    'required'
                ]
            },
            'partnerPreviousFundName': {
                'label': 'Previous Fund Name',
                'labelStyle': '',
                'name': 'partnerPreviousFundName',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Select their previous fund\'s name.',
                'validation': [
                    'required'
                ],
                'options': []
            },
            'partnerPreviousFundMemberNumber': {
                'label': 'Member Number (optional)',
                'labelStyle': '',
                'name': 'partnerPreviousFundMemberNumber',
                'modelChild': 'partner',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 20,
                'tooltip': 'If you have their member number handy, enter it here.',
                'validation': []
            },
            // 'partnerContinuousCover': {
            //     'label': '',
            //     'labelStyle': '',
            //     'name': 'partnerContinuousCover',
            //     'defaultValue': '',
            //     'placeholder': '',
            //     'tooltip': 'The Federal Government Lifetime Health Cover initiative rewards those who take out Hospital cover before they turn 31. People who delay taking out Hospital cover will pay an additional 2% loading on top of their contributions for every year that they don\'t have Hospital cover over the age of 30. The loading ceases to apply once Hospital cover has been held for ten continuous years.',
            //     'options': [
            //         {
            //             'label': 'My partner has held continuous private hospital cover for the past 10 years (or since their 31st birthday)'
            //         }
            //     ],
            //     'validation': []
            // },
            'partnerContinuousCover': {
                'label': 'My partner has held continuous private hospital cover for the past 10 years (or since their 31st birthday)',
                'labelStyle': '',
                'name': 'partnerContinuousCover',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'The Federal Government Lifetime Health Cover initiative rewards those who take out Hospital cover before they turn 31. People who delay taking out Hospital cover will pay an additional 2% loading on top of their contributions for every year that they don\'t have Hospital cover over the age of 30. The loading ceases to apply once Hospital cover has been held for ten continuous years.',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': []
            },

            'dependantRelationship': {
                'label': 'Relationship',
                'labelStyle': '',
                'name': 'dependantRelationship',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [],
                'onChange': function (newValue, oldValue, dependantModel, formModel, field) {
                    // Find the first item that matches the value.
                    var title = _.find(field.options, { value: newValue });
                    if (title.gender) {
                        dependantModel.dependantGender = title.gender;
                    }
                }
            },
            'dependantFirstName': {
                'label': 'First Name',
                'labelStyle': '',
                'name': 'dependantFirstName',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 16,
                'validation': [
                    'required'
                ]
            },
            'dependantLastName': {
                'label': 'Last Name',
                'labelStyle': '',
                'name': 'dependantLastName',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'maxLength': 25,
                'validation': [
                    'required'
                ]
            },
            'dependantDOB': {
                'label': 'Date Of Birth',
                'name': 'dependantDOB',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': 'DD/MM/YYYY',
                'datePickerOptions': {
                    yearRange: '-110nn:-nn',
                    minDate: moment().subtract(joinFormPageData.dependantMaxAge, 'years').subtract(1, 'day').toDate(),
                    maxDate: moment().toDate(),
                    defaultDate: moment().format('DD/MM/YYYY')
                },
                'tooltip': '',
                'validation': [
                    'required',
                    'thfDateOfBirth',
                    'thfDateOfBirthDependant'
                ]
            },
            'dependantGender': {
                'label': 'Gender',
                'labelStyle': '',
                'name': 'dependantGender',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': [
                    { 'label': 'Male', 'value': 'M' },
                    { 'label': 'Female', 'value': 'F' }
                ]
            },
            'dependantTertiary': {
                'label': 'Is this person a full-time student, trainee or apprentice for the current calendar year?',
                'labelStyle': '',
                'name': 'dependantTertiary',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': []
            },
            'dependantTertiaryInstitute': {
                'label': 'Name of university/college/employer',
                'labelStyle': '',
                'name': 'dependantTertiaryInstitute',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': '',
                'validation': []
            },
            'dependantPreviousFundSwitching': {
                'label': 'Are they switching from another policy?',
                'labelStyle': '',
                'name': 'dependantPreviousFundSwitching',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'tooltip': 'Select their previous fund\'s name.',
                'options': [
                    { 'label': 'Yes', 'value': 'Y' },
                    { 'label': 'No', 'value': 'N' }
                ],
                'validation': [
                    'required'
                ]
            },
            'dependantPreviousFundName': {
                'label': 'Previous Fund Name',
                'labelStyle': '',
                'name': 'dependantPreviousFundName',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': 'Select their previous fund name',
                'tooltip': '',
                'validation': [
                    'required'
                ],
                'options': []
            },
            'dependantPreviousFundMemberNumber': {
                'label': 'Member Number (optional)',
                'labelStyle': '',
                'name': 'dependantPreviousFundMemberNumber',
                'modelChild': 'dependants',
                'defaultValue': '',
                'placeholder': '',
                'maxLength': 20,
                'tooltip': 'If you have their member number handy, enter it here.',
                'validation': []
            }

        };
    });
})(angular);
